import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import AmazonInspectorConfigListing from './AmazonInspectorConfigListing'
import AmazonInspectorCredentialsForm from './AmazonInspectorCredentialsForm'

export default function AmazonInspectorPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={AmazonInspectorCredentialsForm}
            PullConfigListingView={AmazonInspectorConfigListing}
        />
    )
}